import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.scss';
import { faBox, faPager, faPencilSquare } from '@fortawesome/free-solid-svg-icons';
import { useRouter } from 'next/navigation';
import axios from 'axios';
import { useSession } from 'next-auth/react';

import successMsg from '../../../Functions/successMsg';
import errorMsg from '../../../Functions/errorMsg';

import { useLoading } from '../../../Context/useLoading';

export default function CreateAccount({ setAccountCreated }) {
  const router = useRouter();
  const { data: session, status } = useSession();

  const { addProcess, removeProcess, processExists } = useLoading();

  async function openAccount(e) {
    e.preventDefault();
    if (processExists('creatingAccount')) return;

    if (!session || status === 'unauthenticated') return router.push('/account/login');

    addProcess('creatingAccount');

    try {
      const result = await axios.get(`${window.location.origin}/api/vendor/helpers/openAccount`);

      if (result && result.status === 200) {
        setAccountCreated(true);
        successMsg('Your account was opened successfully!');
      }
    } catch (error) {
      errorMsg('Failed to open account');
    } finally {
      removeProcess('creatingAccount');
    }
  }

  return (
    <section id={styles.wrapper}>
      <div id={styles.container}>
        <section id={styles.content}>
          <h1>Vendor Program</h1>
          <p>Catalog your products & services</p>
        </section>

        <section id={styles.details}>
          <div>
            <FontAwesomeIcon icon={faPager} id={styles.icon} />
            <p>Gain access to your own eCommerce page</p>
          </div>
          <div>
            <FontAwesomeIcon icon={faBox} id={styles.icon} />
            <p>Accept orders online and track your inventory</p>
          </div>
          <div>
            <FontAwesomeIcon icon={faPencilSquare} id={styles.icon} />
            <p>Gain profile ratings and reviews from your customers</p>
          </div>
        </section>

        <section id={styles.buttonGroup}>
          <button onClick={openAccount}>Open Account</button>
        </section>
      </div>
    </section>
  );
}
